import { Component, OnDestroy, OnInit } from '@angular/core';
import { fromEvent, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { VoltarAoTopoService } from './volta-ao-topo.service';


@Component({
  selector: 'rot-voltar-ao-topo',
  templateUrl: './voltar-ao-topo.component.html',
  styleUrls: ['./voltar-ao-topo.component.scss']
})
export class VoltarAoTopoComponent implements OnInit, OnDestroy {
  menuVisivel = true;
  private destroy$ = new Subject<void>();
  constructor(private voltaAoTopoService: VoltarAoTopoService) {}

  ngOnInit(): void {
    this.voltaAoTopoService
      .ativarEventoScroll()
      .subscribe(this.ativarEventoScroll.bind(this));

    this.voltaAoTopoService
      .desativarEventoScroll()
      .subscribe(this.desativarEventoScroll.bind(this));
  }


  ativarEventoScroll() {
    fromEvent(window, 'scroll')
      .pipe(debounceTime(300), distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(this.scroll.bind(this));
  }

  desativarEventoScroll() {
    this.menuVisivel = true;
    this.destroy$.next();
    this.destroy$.complete();
  }

  scroll() {
    const elemento = document.querySelector('#topoId');
    if (elemento) {
      const posicoes = elemento.getBoundingClientRect();
      this.menuVisivel = posicoes.top >= 0 && posicoes.bottom <= window.innerHeight;
    }
  }

  ngOnDestroy(): void {
    this.desativarEventoScroll();
    this.voltaAoTopoService.desativarEventos();
  }
}
